import type { ExpenseStatus } from '../../types/expense';

const STYLES: Record<ExpenseStatus, { label: string; cls: string }> = {
    Draft: { label: 'Draft', cls: 'bg-amber-100 text-amber-800' },
    Submitted: { label: 'Submitted', cls: 'bg-blue-100 text-blue-800' },
    Reconciled: { label: 'Reconciled', cls: 'bg-indigo-100 text-indigo-800' },
    Approved: { label: 'Approved', cls: 'bg-green-100 text-green-800' },
    Rejected: { label: 'Rejected', cls: 'bg-red-100 text-red-800' },
    Exported: { label: 'Exported', cls: 'bg-gray-200 text-gray-700' },
};

export function StatusChip({ status }: { status: ExpenseStatus }) {
    const s = STYLES[status] ?? { label: status, cls: 'bg-gray-100 text-gray-700' };
    return (
        <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${s.cls}`}>
            {s.label}
        </span>
    );
}
